import { Quote } from '@/types';

/**
 * Props for the QuoteContent component
 */
interface QuoteContentProps {
  /** The quote object to display */
  quote: Quote;
}

/**
 * Displays a quote in a terminal-style format with text, attribution, and blinking cursor
 * 
 * @param props - The component props
 * @returns A formatted quote display with terminal styling
 */
function QuoteContent({ quote }: QuoteContentProps) {
  return (
    <div data-testid="quote-content">
      <p className="whitespace-pre-wrap" data-testid="quote-text">
        <span className="text-brand-text">$&nbsp;</span>
        <span>&quot;{quote.text}&quot;</span>
        <span className="w-2 h-5 bg-brand-amber animate-blink inline-block ml-1"></span>
      </p>
      <p className="mt-4 text-brand-heading" data-testid="quote-attribution">
        <span className="text-brand-text">#&nbsp;</span>— {quote.author}
        {quote.source && (
          <span className="text-brand-muted">, {quote.source}</span>
        )}
      </p>
    </div>
  );
}

export default QuoteContent;
